// @ts-nocheck
import {
  FindingTriageState,
  IssueStatus,
  Severity,
} from "@protos/common/v1/common";
import {
  AggregateIssueState,
  Issue,
  Issue_ActivityHistoryEvent,
  Issue_ActivityHistoryEvent_HistoryType,
} from "@protos/issues/v1/issues";

// Manually copied these interfaces from `@shared/findings/types` to avoid circular dependencies
interface Position {
  line: number;
  col: number;
  offset: number;
}

interface CodeLocation {
  path: string;
  start: Position;
  end: Position;
}

type CodeLocationWithUrl = CodeLocation & {
  location_url?: string;
};

interface DataflowTrace {
  taint_source: CodeLocationWithUrl[];
  intermediate_vars?: CodeLocationWithUrl[];
  taint_sink: CodeLocationWithUrl[];
}

export const StorybookFinding: Issue = Issue.create({
  id: 10837,
  ref: "develop",
  syntacticId: "db926788aea5f08e625ae6709dbd2a97",
  matchBasedId: undefined,
  rulePath: "python.flask.security.open-redirect.open-redirect",
  filePath: "server/build/lib/semgrep_app/app.py",
  line: 520,
  column: 5,
  message:
    "Data from request is passed to redirect(). This is an open redirect and could be exploited. Consider using 'url_for()' to generate links to known locations. If you must use a URL to unknown pages, consider using 'urlparse()' or similar and checking if the 'netloc' property is the same as your site's host name. See the references for more information.",
  severity: Severity.HIGH,
  endLine: 529,
  endColumn: 45,
  ruleReferences: [
    "https://flask-login.readthedocs.io/en/latest/#login-example",
    "https://cheatsheetseries.owasp.org/cheatsheets/Unvalidated_Redirects_and_Forwards_Cheat_Sheet.html#dangerous-url-redirect-example-1",
    "https://docs.python.org/3/library/urllib.parse.html#url-parsing",
  ],
  policySlug: "web-apps",
  ruleset: "r2c-security-audit",
  ruleUrl:
    "https://semgrep.dev/r/python.flask.security.open-redirect.open-redirect",
  status: IssueStatus.UNRESOLVED,
  repository: {
    name: "returntocorp/semgrep-app",
  },
  firstSeenScan: {
    id: 16339,
    meta: {
      repository: "returntocorp/semgrep-app",
      repo_url: "https://github.com/jesse-r2c/juice-shop",
      branch: "develop",
      ci_job_url:
        "https://github.com/jesse-r2c/juice-shop/actions/runs/2282792114",
      commit: "774aea6d0fc82ff988f5d2cd9b878b2c33584230",
      commit_author_email: "chmccreery@gmail.com",
      commit_author_name: "Clara McCreery",
      commit_author_username: "dev-semgrep-app[bot]",
      commit_author_image_url:
        "https://avatars.githubusercontent.com/u/29760937?v=4",
      commit_title: "add submodules:true to release-snowflake (#4100)",
      on: "unknown",
      pull_request_author_username: null,
      pull_request_author_image_url: null,
      pull_request_id: null,
      pull_request_title: null,
      scan_environment: "git",
      ignored_files: ["/server/semgrep_app/templates/"],
    },
  },
  lastSeenScan: {
    id: 32378,
    meta: {
      semgrep_version: "0.91.0",
      repository: "jesse-r2c/juice-shop",
      repo_url: "https://github.com/jesse-r2c/juice-shop",
      branch: "refs/heads/master",
      ci_job_url:
        "https://github.com/jesse-r2c/juice-shop/actions/runs/2282792114",
      commit: "05b4b5f83d014bb1b655590e4326c113b636137e",
      commit_author_email: "support@r2c.dev",
      commit_author_name: "semgrep.dev on behalf of @jesse-r2c",
      commit_author_username: "dev-semgrep-app[bot]",
      commit_author_image_url:
        "https://avatars.githubusercontent.com/u/29760937?v=4",
      commit_title: "Add Semgrep CI",
      on: "push",
      pull_request_author_username: null,
      pull_request_author_image_url: null,
      pull_request_id: null,
      pull_request_title: null,
      scan_environment: "github-actions",
      is_full_scan: true,
      ignored_files: [],
    },
  },
  triageState: FindingTriageState.UNTRIAGED,
  relevantSince: new Date(Date.parse("Fri, 03 Dec 2021 02:48:15 GMT")),
  created_at: new Date(Date.parse("Tue, 01 Dec 2022 20:01:09 GMT")),
  aggregate_state: AggregateIssueState.OPEN,
  note: "Foo bar",
  activityHistory: [
    Issue_ActivityHistoryEvent.create({
      note: "I think Jesse is the coolest dude on planet earth",
      state: "ignored",
      date: new Date(Date.parse("Fri, 12 Aug 2022 17:39:26 GMT")),
      actor: "chmccreery",
      historyType: Issue_ActivityHistoryEvent_HistoryType.TRIAGE,
    }),
    {
      note: "Couldn't agree more Clara!",
      state: "reopened",
      date: new Date(Date.parse("Tue, 16 Aug 2022 16:14:29 GMT")),
      actor: "adamboros",
      historyType: Issue_ActivityHistoryEvent_HistoryType.TRIAGE,
    },
    {
      note: "😎",
      state: "",
      date: new Date(Date.parse("Sat, 27 Aug 2022 02:42:17 GMT")),
      actor: "jesse-r2c",
      historyType: Issue_ActivityHistoryEvent_HistoryType.TRIAGE,
    },
    {
      note: "",
      state: "muted",
      date: new Date(Date.parse("Sat, 27 Jan 2023 02:42:17 GMT")),
      actor: null,
      historyType: Issue_ActivityHistoryEvent_HistoryType.STATUS,
    },
    {
      note: "",
      state: "unresolved",
      date: new Date(Date.parse("Sat, 27 Jan 2023 02:42:17 GMT")),
      actor: null,
      historyType: Issue_ActivityHistoryEvent_HistoryType.STATUS,
    },
  ],
  relatedIssues: [],
});

export const STORYBOOK_EXAMPLE_REPO: Repo = {
  id: 0,
  deployment_id: 1,
  name: "test-repo",
  policies: [],
  ignored_files: null,
  provisioned_at: "2021-01-01T00:00:00Z",
  first_scan_id: 0,
  latest_scan_id: 1,
  latest_scan: {
    id: 1,
    repository_id: 1,
    meta: {
      ci_job_url: "https://example.com",
    },
  },
  latest_scan_at: "2021-01-02T01:01:01Z",
  latest_full_sca_scan_at: null,
  autofix: false,
  is_disconnected: false,
  sca_settings: {},
  sca_info: { dependency_counts: { "yarn.lock": 1243 } },
};

export const STORYBOOK_EXAMPLE_POLICY = {
  name: "default",
  slug: "default",
  repos: [],
  rules: [],
  is_default: true,
  notifications: [],
  pr_comments: false,
  blocking: false,
  description: "",
  overrides: [],
};

export const dataflowTrace: DataflowTrace = {
  taint_source: [
    {
      path: "build_tools/azure/get_commit_message.py",
      start: { line: 8, col: 36, offset: 146 },
      end: { line: 8, col: 46, offset: 156 },
    },
  ],
  intermediate_vars: [
    {
      path: "build_tools/azure/get_commit_message.py",
      start: { line: 8, col: 5, offset: 115 },
      end: { line: 8, col: 33, offset: 143 },
      location_url: "https://github.com/",
    },
    {
      path: "build_tools/azure/get_commit_message.py",
      start: { line: 14, col: 9, offset: 459 },
      end: { line: 14, col: 18, offset: 468 },
    },
    {
      path: "build_tools/azure/get_commit_message.py",
      start: { line: 15, col: 9, offset: 519 },
      end: { line: 15, col: 16, offset: 526 },
    },
  ],
  taint_sink: [
    {
      path: "build_tools/azure/get_commit_message.py",
      start: { line: 17, col: 13, offset: 629 },
      end: { line: 17, col: 20, offset: 636 },
    },
  ],
};

export const multifileDataflowTrace: DataflowTrace = {
  taint_source: [
    {
      path: "build_tools/azure/get_commit_message.py",
      start: { line: 8, col: 36, offset: 146 },
      end: { line: 8, col: 46, offset: 156 },
    },
  ],
  intermediate_vars: [
    {
      path: "build_tools/azure/get_commit_message.py",
      start: { line: 8, col: 5, offset: 115 },
      end: { line: 8, col: 33, offset: 143 },
    },
    {
      path: "build_tools/azure/get_commit_message_2.py",
      start: { line: 14, col: 9, offset: 459 },
      end: { line: 14, col: 18, offset: 468 },
    },
    {
      path: "build_tools/azure/get_commit_message_2.py",
      start: { line: 15, col: 9, offset: 519 },
      end: { line: 15, col: 16, offset: 526 },
    },
  ],
  taint_sink: [
    {
      path: "build_tools/azure/get_commit_message_3.py",
      start: { line: 17, col: 13, offset: 629 },
      end: { line: 17, col: 20, offset: 636 },
    },
  ],
};

export const StorybookFindingWithDataflow: Finding = {
  aggregate_state: "open",
  check_id:
    "python.lang.security.audit.dangerous-subprocess-use-tainted-env-args.dangerous-subprocess-use-tainted-env-args",
  column: 13,
  end_column: 20,
  end_line: 17,
  line: 17,
  message:
    "Detected subprocess function 'run' with user controlled data. A malicious actor could leverage this to perform command injection. You may consider using 'shlex.escape()'.",
  confidence: "MEDIUM",
  references: [
    "https://stackoverflow.com/questions/3172470/actual-meaning-of-shell-true-in-subprocess",
    "https://docs.python.org/3/library/subprocess.html",
    "https://docs.python.org/3/library/shlex.html",
    "https://semgrep.dev/docs/cheat-sheets/python-command-injection/",
  ],
  policy_slug: "rule-board-audit",
  ruleset: "python",
  rule_url:
    "https://semgrep.dev/r/python.lang.security.audit.dangerous-subprocess-use-tainted-env-args.dangerous-subprocess-use-tainted-env-args",
  path: "build_tools/azure/get_commit_message.py",
  severity: 2,
  syntactic_id: "d67f5446ddad0f7723f8d2a152153130",
  dataflow_trace: dataflowTrace,
  first_seen_scan: {
    id: 33420,
    meta: {
      branch: "main",
      ci_job_url: null,
      commit: "ce89a4ff155cf1ec06e991a2910ca3b3c0224394",
      commit_author_email: "g.lemaitre58@gmail.com",
      commit_author_image_url: null,
      commit_author_name: "Guillaume Lemaitre",
      commit_author_username: null,
      commit_title:
        "MAINT use parameter validation framework for ColumnTransformer (#25137)\n\nCo-authored-by: Jérémie du Boisberranger <34657725+jeremiedbb@users.noreply.github.com>",
      is_full_scan: true,
      is_sca_scan: false,
      on: "unknown",
      pull_request_author_image_url: null,
      pull_request_author_username: null,
      pull_request_id: null,
      pull_request_title: null,
      renamed_paths: [],
      repo_url: null,
      repository: "scikit-learn",
      scan_environment: "git",
      semgrep_version: "1.2.1",
    },
  },
  id: 22436,
  is_blocking: false,
  line_of_code_url: null,
  match_based_id:
    "c6bde03ac848f01d4b1bb62b633f4ac666564dee933eaa2e471bf492a8e41004b0df5889e3fdd8766bd2eefb6da3d007167a6fd78e47b184bd9239a1f32af5d7_0",
  note: null,
  ref: "main",
  relevant_since: "Wed, 21 Dec 2022 20:01:09 GMT",
  created_at: "Tue, 20 Dec 2022 20:01:09 GMT",
  removed_by_pr_event: false,
  repository: { name: "scikit-learn" },
  review_count: 0,
  rule_id: 1660804,
  state: "unresolved",
  triage_count: 0,
  triage_reason: null,
  triage_state: "untriaged",
};
